<template>
    <div>
        <div v-for="(groupedEvent, index) in pastEvents">
            <div
                class="flex items-baseline px-4 lg:px-12"
                :class="index === 0 ? 'justify-end md:justify-between' : 'justify-end'"
            >
                <p class="text-grey hidden md:block" v-if="index === 0">{{ $t('events.past') }}</p>

                <div class="text-right text-3xl md:text-5xl text-grey p-4" :class="index === 0 ? 'py-6 md:pb-3 md:mt-20' : 'py-6'">
                    {{ groupedEvent.year }}
                </div>
            </div>

            <div v-for="(event, index) in groupedEvent.events" :key="event.id">
                <MoleculeCardEvent :class="{ '!border-b-0': index + 1 !== groupedEvent.events.length }" :event="event"/>
            </div>
        </div>
    </div>
</template>

<script>
import MoleculeCardEvent from "./MoleculeCardEvent.vue";

export default {
    name: "MoleculePastEvent",
    components: {MoleculeCardEvent},
    props: {
        events: null
    },
    computed: {
        pastEvents() {
            const currentDate = new Date();

            const groupedAndSortedEvents = this.events.reduce((result, event) => {
                const eventDate = new Date(event.finishing_date);
                if (eventDate < currentDate) {
                    const year = eventDate.getFullYear();
                    if (!result.some(entry => entry.year === year)) {
                        result.push({ year, events: [] });
                    }
                    const yearEntry = result.find(entry => entry.year === year);
                    yearEntry.events.push(event);
                }
                return result;
            }, []);

            groupedAndSortedEvents.sort((a, b) => b.year - a.year);

            return groupedAndSortedEvents;
        },
    },
}
</script>
